// src/components/Admin/InstitutionCmp/InstitutionProfile/InstitutionProfile.js
import React from "react";
import { Table, Image } from "semantic-ui-react";

export function InstitutionProfile({ data }) {
  const {
    avatar,
    institutionnam,
    created_at,
    firstname,
    lastname,
    email,
    phone,
    website,
    address,
    city,
    country,
    studentsnum,
    teachersnum,
  } = data;

  const fmt = iso => iso ? new Date(iso).toLocaleDateString() : "–";

  return (
    <Table definition compact>
      <Table.Body>
        <Table.Row>
          <Table.Cell><Image src={avatar} avatar size="mini" /></Table.Cell>
          <Table.Cell>{institutionnam}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Alta</Table.Cell>
          <Table.Cell>{fmt(created_at)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Contacto</Table.Cell>
          <Table.Cell>{firstname} {lastname}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Email</Table.Cell>
          <Table.Cell>{email}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Teléfono</Table.Cell>
          <Table.Cell>{phone || "–"}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Web</Table.Cell>
          <Table.Cell>
            {website
              ? <a href={website} target="_blank" rel="noopener noreferrer">{website}</a>
              : "–"}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Dirección</Table.Cell>
          <Table.Cell>{address}, {city}, {country}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Licencias Alumnos</Table.Cell>
          <Table.Cell>{studentsnum}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Licencias Profesores</Table.Cell>
          <Table.Cell>{teachersnum}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}
